export default __webpack_public_path__ + "static/media/Eject_Tip.f9358991.svg";